import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import StopIcon from "@mui/icons-material/Stop";
import { getAIServerList } from "../../services/serverRuleService.js"; //TODO: 여기까지함

export default function ServerSelectModal({
  open,
  onClose,
  setSelectedServer,
  changeMode,
  nowServer,
}) {
  const [aiServerList, setAIServerList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "fit-content",
    bgcolor: "white",
    border: "1px solid var(--stroke-color)",
    borderRadius: "4px",
    boxShadow: 24,
    p: 2,
  };
  useEffect(() => {
    setIsLoading(true);
    const fetchServer = async () => {
      try {
        const response = await getAIServerList();
        if (changeMode) {
          const filteredList = response.filter((server) => {
            return server.serverAddress !== nowServer;
          });
          setAIServerList(filteredList);
        } else {
          setAIServerList(response);
        }
      } catch (error) {
        console.error("Error fetching server list:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchServer();
  }, []);

  // tag 에 train 이 포함되어 있는지 확인
  const isTrainTagIncluded = (tag) => {
    if (!tag) return false;
    return tag.split(",").some((t) => t.trim().includes("train"));
  };

  const handleChoice = (ip) => {
    if (changeMode) {
      const confirm = window.confirm(
        "모듈을 저장하지 않으면 학습했던 내용이 사라집니다. \n서버를 변경 하시겠습니까?"
      );
      if (confirm) {
        // saveModuleOpen(true);
        setSelectedServer(ip);
      } else {
        return;
      }
    } else {
      setSelectedServer(ip);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box className="form-container" sx={modalStyle}>
        <Box>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              my: 2,
              fontWeight: "700",
              color: "var(--text-color)",
            }}
            fontFamily={"NotoSansKR-Variable"}
          >
            {changeMode ? "Change" : "Select"} Server
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              sx={{
                color: "var(--text-color)",
                // ml: 1,
              }}
            >
              {changeMode ? "변경할" : "학습을 진행할"} 서버를 선택해주세요.
            </Typography>
            {changeMode && (
              <Typography
                sx={{
                  color: "var(--text-color)",
                  ml: 2,
                }}
              >
                현재 서버: [{nowServer}]
              </Typography>
            )}
          </Box>
        </Box>
        {isLoading ? (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress style={{ color: "var(--text-color)" }} />
          </Box>
        ) : (
          <Table
            sx={{
              border: "1px solid lightgray",
            }}
          >
            <TableHead>
              <TableRow className="th-row">
                <TableCell>Server</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Tag</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {aiServerList &&
                aiServerList.map((row) => (
                  <TableRow key={row.id} className="table-row">
                    <TableCell>{row.serverAddress}</TableCell>
                    <TableCell>temp</TableCell>
                    <TableCell>{row.identifier}</TableCell>
                    <TableCell>{row.tag}</TableCell>
                    <TableCell>
                      <Button
                        style={{
                          marginLeft: "10px",
                          color: isTrainTagIncluded(row.tag)
                            ? "var(--button-color)"
                            : "gray",
                        }}
                        disabled={!isTrainTagIncluded(row.tag)}
                        onClick={() => {
                          handleChoice(row.serverAddress);
                        }}
                        variant="outlined"
                      >
                        {changeMode ? "변경" : "선택"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </Box>
    </Modal>
  );
}
